/* eslint-disable @ts-intl/ts-intl/no-raw-text */
import { currentWallet, useDesiredChain } from '@cronos-app/wallet';
import { BigNumber } from '@ethersproject/bignumber';
import type { QueryKey } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { getSDK } from '@ui/utils';

export const getUseUserPendingRewardKey = (
  account: string | undefined,
): QueryKey => ['BaraVault.PendingReward', account];

const useUserPendingReward = () => {
  const desiredChainId = useDesiredChain();
  const sdk = getSDK(desiredChainId);
  const account = currentWallet.useAccount();
  const provider = currentWallet.useProvider();
  const isWrongNetwork = currentWallet.useIsWrongNetwork();

  const data = useQuery(
    getUseUserPendingRewardKey(account),
    async () => {
      const signer = await provider?.getSigner();
      const baraVaultContract = sdk.getBaraVault(signer);

      if (account && !isWrongNetwork) {
        const pendingReward = await baraVaultContract.pendingReward(account);

        return BigNumber.from(pendingReward);
      }

      return BigNumber.from(0);
    },
    {
      enabled: !!account && !isWrongNetwork,
    },
  );

  return data;
};

export default useUserPendingReward;
